<div class="form-group">
  <app-label-info [info]="info" *ngIf="label"
    >{{ label }}
    <span class="required-asterisk" [class.invalid]="invalid" *ngIf="required || _errors?.required"
      >*</span
    ></app-label-info
  >
  <div class="ui-inputgroup">
    <ng-content select="[prepend]"></ng-content>
    <ng-container [ngSwitch]="controlType">
      <input
        pInputText
        *ngSwitchCase="'PHONE'"
        [formControl]="formControl"
        type="{{ type || 'text' }}"
        (blur)="onTouch()"
        [readOnly]="readOnly"
        [placeholder]="placeholder"
        pTooltip="{{ tooltip }}"
        tooltipPosition="{{ tooltipPosition }}"
        [pKeyFilter]="phoneFilter"
        (change)="phoneChange($event.target.value)"
        (keyup)="phoneChange($event.target.value)"
        [maxlength]="maxlength"
      />

      <p-inputNumber
        (onBlur)="onTouch()"
        [min]="min"
        [max]="max"
        [class]="class"
        *ngSwitchCase="'LOCALIZED_NUMBER'"
        [formControl]="formControl"
        [locale]="locale"
        [placeholder]="placeholder"
        pTooltip="{{ tooltip }}"
        tooltipPosition="{{ tooltipPosition }}"
        [maxlength]="maxlength"
      >
      </p-inputNumber>
      <input
        pInputText
        *ngSwitchCase="'INPUT'"
        [formControl]="formControl"
        type="{{ type || 'text' }}"
        (blur)="onTouch()"
        [readOnly]="readOnly"
        [placeholder]="placeholder"
        pTooltip="{{ tooltip }}"
        tooltipPosition="{{ tooltipPosition }}"
        [pKeyFilter]="pKeyFilter"
        [min]="min"
        [max]="max"
        [maxlength]="maxlength" 
        (keyup)="onChangeEvent ? onChangeEvent($event, ngControl, options) : null"
      />

      <ng-container *ngSwitchCase="'URL'">
        <span class="ui-inputgroup-addon">https://</span>
        <input
          type="text"
          pInputText
          [formControl]="formControl"
          type="{{ type }}"
          class="form-control"
          (blur)="onTouch()"
          [readOnly]="readOnly"
          [placeholder]="placeholder"
          pTooltip="{{ tooltip }}"
          tooltipPosition="{{ tooltipPosition }}"
          [pKeyFilter]="pKeyFilter"
        />
      </ng-container>

      <p-inputMask
        *ngSwitchCase="'INPUT_MASK'"
        [placeholder]="placeholder"
        [formControl]="formControl"
        (blur)="onTouch()"
        [mask]="mask"
        pTooltip="{{ tooltip }}"
        tooltipPosition="{{ tooltipPosition }}"
      ></p-inputMask>

      <textarea
        *ngSwitchCase="'TEXTAREA'"
        [formControl]="formControl"
        pInputTextarea
        class="form-control"
        (blur)="onTouch()"
        pTooltip="{{ tooltip }}"
        tooltipPosition="{{ tooltipPosition }}"
      ></textarea>

      <ng-container *ngSwitchCase="'SELECT'">
        <!--
          Note: there's an inssue where optionLabel cant be binded.
          It has to be interpolated
        -->
        <p-dropdown
          (blur)="onTouch()"
          class="col-12"
          [formControl]="formControl"
          [options]="options"
          [filter]="true"
          [filterBy]="filterBy"
          optionLabel="{{ optionLabel }}"
          placeholder="{{ 'selectOption' | translate }}"
          [readonly]="readOnly"
          [dataKey]="dataKey"
          [selectId]="selectId"
          pTooltip="{{ tooltip }}"
          tooltipPosition="{{ tooltipPosition }}"
          [appendTo]="appendDropdown"
          (onChange)="onChangeEvent ? onChangeEvent($event, ngControl, options) : null"
        ></p-dropdown>
      </ng-container>

      <p-multiSelect
        *ngSwitchCase="'MULTISELECT'"
        [formControl]="formControl"
        class="col-12"
        [options]="options"
        optionLabel="name"
        pTooltip="{{ tooltip }}"
        [appendTo]="appendDropdown"
        tooltipPosition="{{ tooltipPosition }}"
      ></p-multiSelect>

      <p-multiSelect
        *ngSwitchCase="'MULTISELECTFIXLABEL'"
        [formControl]="formControl"
        defaultLabel="{{ 'selectOption' | translate }}"
        class="col-12 p-0"
        [options]="options"
        optionLabel="{{ optionLabel }}"
        selectedItemsLabel = "{0} {{ 'multiSelectOption' | translate }}"
        pTooltip="{{ tooltip }}"
        [appendTo]="appendDropdown"
        tooltipPosition="{{ tooltipPosition }}"
      ></p-multiSelect>

      <partnerhub-radio-button-group
        *ngSwitchCase="'RADIOGROUP'"
        [formControl]="formControl"
        [horizontal]="_horizontal"
        [options]="options"
        [groupName]="groupName"
        [dataKey]="dataKey"
        [selectId]="selectId"
        [returnAsObject]="returnAsObject"
        [optionLabel]="optionLabel"
      ></partnerhub-radio-button-group>

      <partnerhub-checkbox-button-group
        *ngSwitchCase="'CHECKBOXGROUP'"
        [formControl]="formControl"
        [horizontal]="_horizontal"
        [options]="options"
        [groupName]="groupName"
      >
      </partnerhub-checkbox-button-group>

      <partnerhub-calendar
        *ngSwitchCase="'CALENDAR'"
        [formControl]="formControl"
        [monthNavigator]="monthNavigator"
        [yearNavigator]="yearNavigator"
        [yearRange]="yearRange"
        [dataType]="dataType"
        [placeholder]="placeholder"
        pTooltip="{{ tooltip }}"
        class="w-100"
        tooltipPosition="{{ tooltipPosition }}"
        [dateFormat]="dateFormat"
        [showButtonBar]="showButtonBar"
      >
      </partnerhub-calendar>

      <p-calendar
        [showIcon]="true"
        #rangeCalendar
        (onSelect)="onDatesRangeFilterSelected()"
        [placeholder]="placeholder"
        *ngSwitchCase="'RANGE_CALENDAR'"
        [formControl]="formControl"
        selectionMode="range"
      ></p-calendar>

      <ng-container *ngSwitchCase="'AUTOCOMPLETE'">
        <p-autoComplete [formControl]="formControl" [suggestions]="options" (completeMethod)="autoCompleteEmit($event)" field="name" appendTo="body"></p-autoComplete>
      </ng-container>
    </ng-container>

    <ng-content select="[append]"></ng-content>
  </div>

  <partnerhub-error-validation [invalid]="invalid" [errors]="_errors"></partnerhub-error-validation>
  <partnerhub-error-validation [invalidByBackend]="invalidByBackend"></partnerhub-error-validation>
</div>
